import React from 'react'
import error_triangle_icon from "../../Assets/svg/error_triangle_icon.svg";
import mapid_error_graphic from "../..//Assets/png_jpg/mapid_error_graphic.png";
import useLanguage from '../../Components/common_hooks/useLanguage';
import history from '../../App/actions/history';

function NotFoundPage() {

  const { dict, language } = useLanguage();

  const goHome = () => {
    history.push("/")
  }

  return (
    <main className="main_container">
      <div
        style={{
          height: "calc(100svh - 150px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000, // Pastikan di atas elemen lain
        }}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: ".5rem",
          }}
        >
          <img
            src={error_triangle_icon}
            alt="error sign"
            width={"40rem"}
            style={{ marginBottom: "1rem" }}
          />
          <img
            src={mapid_error_graphic}
            alt="error boundary"
            width={"350rem"}
            style={{ marginBottom: "1rem" }}
          />

          <>
            <h1>{dict?.["Page Not Found"]?.[language]}</h1>
            <p style={{ width: "19rem", textAlign: "center", display: "flex" }}>
              {
                dict?.[
                "Oops, wrong room. Looks like you got lost"
                ]?.[language]
              }
            </p>
          </>

          <button className="button background_red"
            onClick={goHome}
          >
            {dict?.["Home"]?.[language]}
          </button>
        </div>
      </div>
    </main>
  )


}

export default NotFoundPage